import React, { type ReactNode } from 'react';

interface NavigationContextValue {
	toggleSection: (sectionToToggle: string) => void;
	expandedSections: string[];
	selectedRouteSection?: string;
}

const NavigationContext = React.createContext<NavigationContextValue | null>(null);

export interface NavigationProviderProps extends NavigationContextValue {
	children: React.ReactNode;
}

export function NavigationProvider(props: NavigationProviderProps): ReactNode {
	return <NavigationContext.Provider value={props}>{props.children}</NavigationContext.Provider>;
}

export function useNavigationContext<T>(): NavigationContextValue {
	const context = React.useContext(NavigationContext as React.Context<NavigationContextValue | null>);

	if (context === null) {
		throw new Error('useNavigationContext must be used within a NavigationProvider');
	}

	return context;
}
